import {
  getValueReduxUtil,
  USER_KEY
} from '@gymaholic/packages'
import { updateNewCustomerDiscountExpiresAtUserAction } from 'modules/training/modules/training-users/actions/updateNewCustomerDiscountExpiresAt/index.js'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current/index.js'

export function handleNewCustomerDiscountExpiresAtUserAction () {
  return (dispatch, getState) => {
    const currentUser = getCurrentTrainingUserSelect(getState())
    const newCustomerDiscountExpiresAt = getValueReduxUtil(currentUser, USER_KEY.NEW_CUSTOMER_DISCOUNT_EXPIRES_AT)
    if (newCustomerDiscountExpiresAt) {
      dispatch(
        updateNewCustomerDiscountExpiresAtUserAction(
          newCustomerDiscountExpiresAt
        )
      )
    }
  }
}
